import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWholeWheatPitaBreadProduct from 'models/BSWholeWheatPitaBreadProduct'
import BSWholeWheatPitaBreadPackage from './BSWholeWheatPitaBreadPackage'

const productOptions = {
  packagingInfo: <BSWholeWheatPitaBreadPackage />,
  productTitle: 'Brand Specific Whole Wheat Pita Bread',
  model: BSWholeWheatPitaBreadProduct,
  validCategories: ['16'],
  validSubCategories: ['012BS'],
  brandSpecific: true,
}

const BSWholeWheatPitaBread = () => <ProductForm product={productOptions} />

export default BSWholeWheatPitaBread
